/** @jsxImportSource @emotion/react */

import { memo, useCallback } from "react";
import { useIntl } from "react-intl";

import { TextareaAutosize } from "@material-ui/core";

import { Label, Button } from "..";
import useCopy from "../../hooks/useCopy";
import { RtmpUrl } from "../../types/event";

import { labelWrapper, codeBlock, btn } from "./styles";

interface Props {
  className?: string;
  disabled?: boolean;
  data?: RtmpUrl;
}

interface RtmpGroupProps {
  disabled: boolean;
  urlLabel: string;
  url: string;
  streamKey: string;
  streamKeyLabel: string;
}

const RtmpGroup = ({ disabled = false, urlLabel, url, streamKeyLabel, streamKey }: RtmpGroupProps) => {
  const intl = useIntl();
  const rtmpCopy = useCopy();
  const streamKeyCopy = useCopy();
  return (
    <>
      <div css={labelWrapper()}>
        <Label text={urlLabel} />
        <Button css={btn} color="primary" size="small" onClick={(): void => rtmpCopy.copy()} disabled={disabled}>
          {intl.formatMessage({ id: "btn.copy" })}
        </Button>
      </div>
      <TextareaAutosize css={codeBlock} readOnly value={url} ref={rtmpCopy.ref} disabled={disabled} />
      <div css={labelWrapper(2)}>
        <Label text={streamKeyLabel} />
        <Button css={btn} color="primary" size="small" onClick={(): void => streamKeyCopy.copy()} disabled={disabled}>
          {intl.formatMessage({ id: "btn.copy" })}
        </Button>
      </div>
      <TextareaAutosize css={codeBlock} readOnly value={streamKey} ref={streamKeyCopy.ref} disabled={disabled} />
    </>
  );
};

const RtmpBlock = ({ className, disabled = false, data }: Props) => {
  const intl = useIntl();

  const getRtmpUrl = useCallback((url: string | undefined) => {
    if (!url) return "";
    return url.split("/").slice(0, -1).join("/");
  }, []);

  const getStreamKeyValue = useCallback((url: string | undefined) => {
    if (!url) return "";
    return url.split("/").pop() || "";
  }, []);

  return (
    <div className={className}>
      <RtmpGroup
        disabled={disabled}
        urlLabel={intl.formatMessage({
          id: "event-detail.rtmp-main",
        })}
        url={getRtmpUrl(data?.main)}
        streamKey={getStreamKeyValue(data?.main)}
        streamKeyLabel={intl.formatMessage({
          id: "event-detail.stream-key",
        })}
      />
      <RtmpGroup
        disabled={disabled}
        urlLabel={intl.formatMessage({
          id: "event-detail.rtmp-backup",
        })}
        url={getRtmpUrl(data?.backup)}
        streamKey={getStreamKeyValue(data?.backup)}
        streamKeyLabel={intl.formatMessage({
          id: "event-detail.stream-key.backup",
        })}
      />
    </div>
  );
};

export default memo(RtmpBlock);
